import { render } from "./GammeFilter.vue?vue&type=template&id=0fb98e2a"
import script from "./GammeFilter.vue?vue&type=script&lang=js"
export * from "./GammeFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__